import React, { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import Tab, { TabGroup as TabGroupLib } from '@amzn/meridian/tab';
import { AdminConfigPaths } from 'src/store/adminConfigPageSlice/common/constants';

// **** Components **** //

/**
 * Toggle the Task/TaskGroup Tables
 */
const TaskConfigurationTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tabNav = (path: string) => navigate(path, { replace: true });
  const { TASKS, TASK_GROUPS, root } = AdminConfigPaths.Task;

  // Go the table when the root is selected
  useEffect(() => {
    if (location.pathname === root) {
      tabNav(TASKS);
    }
  }, [location.pathname]);

  return (
    <TabGroupLib value={location.pathname} onChange={tabNav}>
      <Tab value={TASKS}>Tasks</Tab>
      <Tab value={TASK_GROUPS}>Task Groups</Tab>
    </TabGroupLib>
  );
};

export default TaskConfigurationTabs;
